import { Routes, Route } from "react-router-dom";
import ErrorPage from "../Pages/ErrorPage/index";
import UserActivityReportTable from "../Pages/UserActivityReportTable";

const PublicRoutes = () => {
    return (
        <>
            <Routes>
                <Route path="/notFound" element={<ErrorPage />} />
                <Route path="/deprecated/userActivity" element={<UserActivityReportTable /> } />
            </Routes>
        </>

    );
}

export default PublicRoutes